import {SchemaService} from "@/services/ModelRisk/Admin/SchemaService";
import {RuleService} from "@/services/ModelRisk/Admin/RuleService";
import {RiskModelService} from "@/services/ModelRisk/Admin/RiskModelService";
import {VersionService} from "@/services/ModelRisk/Admin/VersionService";

export class AdminContext {
    schema() { return new SchemaService(); }
    rules() { return new RuleService(); }
    models() { return new RiskModelService(); }
    versions() { return new VersionService(); }
}
